import { render } from "./MessageBar.vue?vue&type=template&id=0f51abc9&scoped=true"
import script from "./MessageBar.vue?vue&type=script&lang=js"
export * from "./MessageBar.vue?vue&type=script&lang=js"

import "./MessageBar.vue?vue&type=style&index=0&id=0f51abc9&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f51abc9"]])

export default __exports__